// extracted by mini-css-extract-plugin
module.exports = {"weekContainer":"Week_weekContainer__3YeR4","wrapper":"Week_wrapper__2RuiT","arrowContainer":"Week_arrowContainer__180mJ","showNav":"Week_showNav__1XNy7"};